<template>
  <page title="Can Use Sticky">
    <demo-card title="暂无示例"></demo-card>
  </page>
</template>

<script>
export default {
  name: "m-can-use-sticky",
};
</script>

<style lang="scss"></style>
